@if (isNutzerverwaltungEnabled) {
  <div class="add-user-button">
    <app-tonal-button
      buttonText="Nutzer hinzufügen"
      (clicked)="matDialog.open(addUser); isPasswordVisible = false"
      [dataTestId]="testIds.buttonAddOIDCUser" />
    <app-table-settings
      [allColumns]="columns"
      [displayedColumns]="displayedColumns"
      [attr.data-testid]="userListTestIds.tableSettingsComponent">
    </app-table-settings>
  </div>
}

<div class="user-table-container">
  <app-generic-table
    (sortChange)="onSortChange()"
    (pageChange)="onPageChange($event)"
    [dataSource]="(userResponse$ | async) ?? []"
    [columnsToDisplay]="displayedColumns"
    [pageSize]="itemsPerPage"
    [pageIndex]="pageIndex"
    [totalItems]="totalItems"
    [isLoading]="(loadingService.isLoading$ | async)!"
    [activeSortKey]="'displayname'"
    (rowClick)="openResetPasswordDialog($event.element)"
    [attr.data-testid]="testIds.tableOIDCUser"></app-generic-table>
</div>

<ng-template #timAdressTemplate let-row>
  @if (row.matrixid) {
    <p>&#64;{{ row.matrixid }}:{{ domain() }}</p>
  } @else {
    <p>&#64;_MATRIX_ID_WIRD_ALSBALD_ZUGEWIESEN_:{{ domain() }}</p>
  }
</ng-template>

<ng-template #resetPassword>
  <div class="reset-password-container">
    <div>
      <p class="dialog-header-text">Passwort zurücksetzen</p>
      <p class="dialog-header-sub-text">Setzen Sie hier das Passwort für den Nutzername zurück</p>
    </div>
    <div class="reset-password-content">
      <div class="reset-password-username">
        <p class="dialog-header-sub-text">Nutzername: {{ selectedUser.username }}</p>
      </div>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="submitPassword()">
        <div class="reset-password-form-container">
          <div class="input-field-container">
            <p class="dialog-form-description">Neues Einmalpasswort</p>
            <div class="input-with-button">
              <input
                matInput
                [attr.data-testid]="testIds.inputResetPassword"
                [type]="isPasswordVisible ? 'text' : 'password'"
                formControlName="password"
                placeholder="Passwort" />
              <button
                class="copy-button"
                [attr.data-testid]="testIds.buttonResetPasswordCopy"
                type="button"
                (click)="copySuggestedPassword()"
                matTooltip="Passwort kopieren">
                <mat-icon svgIcon="duplicate"></mat-icon>
              </button>
              <mat-icon
                class="icon-interaction"
                matSuffix
                tabindex="0"
                (click)="isPasswordVisible = !isPasswordVisible"
                (keydown.enter)="isPasswordVisible = !isPasswordVisible"
                [svgIcon]="isPasswordVisible ? 'eye' : 'eye-slash'" />
            </div>
          </div>
          <div class="input-field-container repeat-password">
            <p class="dialog-form-description">Passwort wiederholen</p>
            <div class="input-with-button">
              <input
                matInput
                [attr.data-testid]="testIds.inputResetPasswordRepeat"
                [type]="isPasswordRepeatVisible ? 'text' : 'password'"
                formControlName="passwordRepeat"
                placeholder="Passwort" />
            </div>
          </div>
        </div>
        <app-password-hint
          [confirmControl]="resetPasswordForm.controls['passwordRepeat']"
          [control]="resetPasswordForm.controls['password']"></app-password-hint>

        <div class="reset-dialog-buttons">
          <app-button
            [attr.data-testid]="testIds.buttonGeneratePassword"
            text="Passwort vorschlagen"
            (keydown)="$event.stopPropagation()"
            (clicked)="suggestPassword()"></app-button>
          <app-button
            [attr.data-testid]="testIds.buttonResetPasswordCancel"
            text="Abrechen"
            (keydown)="$event.stopPropagation()"
            (clicked)="matDialog.closeAll()"></app-button>
          <app-button
            [attr.data-testid]="testIds.buttonResetPasswordSubmit"
            text="Speichern"
            [isPrimary]="true"
            (keydown)="$event.stopPropagation()"
            [isDisabled]="!resetPasswordForm.valid"
            type="submit"></app-button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #addUser>
  <div class="add-user-container">
    <div>
      <p class="dialog-header-text">Neuen Benutzer hinzufügen</p>
      <p class="dialog-header-sub-text">Erstellen Sie hier einen neuen Benutzer</p>
    </div>
    <form [formGroup]="addUserForm" (ngSubmit)="submitAddUser()">
      <div class="add-user-form-container">
        <div class="input-field-container">
          <p class="dialog-form-description">Nutzername</p>
          <input
            matInput
            [attr.data-testid]="testIds.inputAddUserUsername"
            formControlName="username"
            [readonly]="isConfirmationMode"
            placeholder="Username" />
        </div>

        <div class="input-field-container">
          <p class="dialog-form-description">Passwort</p>
          <div class="input-with-button">
            <input
              matInput
              [attr.data-testid]="testIds.inputAddUserPassword"
              [type]="isPasswordVisible ? 'text' : 'password'"
              formControlName="initialPassword"
              [readonly]="isConfirmationMode"
              placeholder="Passwort" />
            <mat-icon
              class="icon-interaction"
              matSuffix
              tabindex="0"
              (click)="isPasswordVisible = !isPasswordVisible"
              (keydown.enter)="isPasswordVisible = !isPasswordVisible"
              [svgIcon]="isPasswordVisible ? 'eye' : 'eye-slash'" />
          </div>
        </div>
        <div class="input-field-container">
          <p class="dialog-form-description">Passwort wiederholen</p>
          <input
            matInput
            [attr.data-testid]="testIds.inputAddUserPasswordRepeat"
            type="password"
            formControlName="initialPasswordRepeat"
            [readonly]="isConfirmationMode"
            placeholder="Passwort wiederholen" />
        </div>
        <app-password-hint
          [confirmControl]="addUserForm.controls['initialPasswordRepeat']"
          [control]="addUserForm.controls['initialPassword']"></app-password-hint>
        <div class="input-field-container">
          <p class="dialog-form-description">Vorname</p>
          <input
            matInput
            [attr.data-testid]="testIds.inputAddUserFirstName"
            formControlName="firstname"
            [readonly]="isConfirmationMode"
            placeholder="Vorname" />
        </div>

        <div class="input-field-container">
          <p class="dialog-form-description">Nachname</p>
          <input
            matInput
            [attr.data-testid]="testIds.inputAddUserLastName"
            formControlName="lastname"
            [readonly]="isConfirmationMode"
            placeholder="Nachname" />
        </div>

        <div class="input-field-container">
          <p class="dialog-form-description">E-Mail</p>
          <input
            matInput
            [attr.data-testid]="testIds.inputAddUserEmailAddress"
            formControlName="emailAddress"
            [readonly]="isConfirmationMode"
            placeholder="E-Mail" />
        </div>
      </div>

      <div>
        @let msgs = addUserErrorMessages;
        @if (msgs.length) {
          <ul>
            @for (msg of msgs; track msg + ':' + $index) {
              <li class="error-message">{{ msg }}</li>
            }
          </ul>
        }

        @if (showSpinner) {
          <div class="dialog-spinner">
            <app-sb-spinner [type]="'spinnerIndeterminate'" />
          </div>
        }
        @if (isConfirmationMode) {
          <div class="dialog-buttons">
            <app-button
              [attr.data-testid]="testIds.buttonAddUserBack"
              text="Zurück"
              (keydown)="$event.stopPropagation()"
              (clicked)="isConfirmationMode = false" />
            <app-button
              [attr.data-testid]="testIds.buttonSubmitAddUser"
              text="Speichern"
              [isPrimary]="true"
              (keydown)="$event.stopPropagation()"
              [isDisabled]="addUserForm.invalid"
              type="submit" />
          </div>
        } @else {
          <div class="dialog-buttons">
            <app-button
              [attr.data-testid]="testIds.buttonAddUserClose"
              text="Abrechen"
              (keydown)="$event.stopPropagation()"
              (clicked)="matDialog.closeAll(); isConfirmationMode = false" />
            <app-button
              [attr.data-testid]="testIds.buttonAddUserContinue"
              text="Weiter"
              [isPrimary]="true"
              (keydown)="$event.stopPropagation()"
              (click)="continueAddUser()"
              [isDisabled]="addUserForm.invalid" />
          </div>
        }
      </div>
    </form>
  </div>
</ng-template>
